export default {
  default: {
    proposalsAccepted: 'Total Accepted (Month)',
    proposalsCreated: 'Total Created (Month)',
  },
}
